import { AppRouteGroup } from 'routing/classes/AppRouteGroup';

export const viewUserProfileRouteGroup = new AppRouteGroup('/i');

export const viewUserProfileRoute =
  viewUserProfileRouteGroup.route(':username');
